export interface IUpdatePwdModalsProps {
  showModals: boolean;
  setShowModals: React.Dispatch<React.SetStateAction<boolean>>;
  resetState: any;
  requireUserCode: boolean;
  operation: MfaOperationType;
  securityAllow: boolean;
  otpAllowed: boolean;
  onSuccess: () => void;
}

export enum MfaOperationType {
  RESET = "RESET",
  CHANGE = "CHANGE",
  MOBILE = "MOBILE",
}
